<template lang="pug">
  .home-date-box.box.box-margin(v-cloak)
    .box-header(v-if="title")
      span.title {{ title }}
    .box-body
      .loading(v-if="isBusy")
        b-spinner.spinner
      .date(v-else)
        div(v-if="year")
          span.value {{ month }}
          span.unit 月
          span.value {{ date }}
          span.unit 日
        div(v-else)
          span.value -
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 介護記録の最新公開日コンポーネント
 */
@Component
export default class HomeDateBox extends Vue {
  /** タイトル */
  @Prop({
    default: () => {
      return "";
    }
  })
  private title!: string;

  /** 年 */
  @Prop({
    default: () => {
      return "";
    }
  })
  private year!: string;

  /** 月 */
  @Prop({
    default: () => {
      return "";
    }
  })
  private month!: string;

  /** 日 */
  @Prop({
    default: () => {
      return "";
    }
  })
  private date!: string;

  /** 年を小さく表示するか否か */
  @Prop({
    default: () => {
      return false;
    }
  })
  private yearSmall!: boolean;

  /** ローディング表示可否 */
  @Prop({
    default: () => {
      return false;
    }
  })
  private isBusy!: boolean;

  /**
   * vue lifecycle created
   */
  private created(): void {
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

.home-date-box {
  .box-header {
    padding-top: 6px;
    padding-bottom: 7px;

    .title {
      @include bold-font();
    }
  }
  .box-body {
    text-align: right;
    padding: 0;

    .loading {
      padding: 9px;
      .spinner {
        width: 30px;
        height: 30px;
        color: $loading;
      }
    }

    .date {
      padding: 0 10px 0 0;
      .value {
        @include font(32px);
        margin-left: 8px;
      }
      .unit {
        @include font();
      }
    }
  }
}
</style>
